module.exports = window.EM.___fcRuntime.vendors.ReactDOM16